// Подрезка отображения — Rule #8 (spec §7). Применяется ПОСЛЕ выбора.
//
// Жёсткий потолок длины поверх уже осмысленно подрезанной LLM-фразы.
// Smart-cut по границе клаузы + «…». Punctuation-robust: нет пунктуации →
// граница слова → крайний случай hard-cut.

const CLAUSE = '.!?;:,—–';

/**
 * @param {string} text
 * @param {number} max
 * @returns {string} text не длиннее ~max (+«…»), без обрыва слова
 */
export function trimDisplay(text, max) {
  const t = (text ?? '').trim();
  if (t.length <= max) return t;

  const window = t.slice(0, max);

  // 1. последняя граница клаузы в окне
  let cut = -1;
  for (let i = window.length - 1; i >= 0; i--) {
    if (CLAUSE.includes(window[i])) {
      cut = i;
      break;
    }
  }

  // клауза слишком близко к началу (или нет) → граница слова
  if (cut < max * 0.5) {
    const sp = window.lastIndexOf(' ');
    cut = sp > 0 ? sp : max; // одно длинное слово → hard-cut
  }

  const head = t.slice(0, cut).replace(/[\s.,;:!?—–-]+$/, '');
  return `${head}…`;
}
